import { AnyAction } from 'redux';
import { SET_CURRENT_USER, USER_LOADING } from '../actions/types';

const initialState = {
	isAuthenticated: false,
	user: {},
	loading: false,
};

export default function (state = initialState, action: AnyAction) {
	// console.log(action, 'AUTH-REDUCER ACTION; TYPE:', action.type);
	switch (action.type) {
		case SET_CURRENT_USER:
			return {
				...state,
				isAuthenticated: Object.keys(action.payload).length > 0,
				user: action.payload,
			};
		case USER_LOADING:
			return {
				...state,
				loading: true,
			};
		default:
			return state;
	}
}
